type ContactUsData = {
  name: string;
  email: string;
  subject: string;
  body: string;
};
function newContactUsData(): ContactUsData {
  return {
    name: "",
    email: "",
    subject: "",
    body: "",
  };
}

export type { ContactUsData };
export { newContactUsData };
